import { getValidToken, ThumbnailToken } from 'components/partials/thumbnail/token-store';

const buildThumbnailUrl = (token: ThumbnailToken, fileName: string | undefined, damageId: string | undefined, cache: boolean): string => {
  const params = new URLSearchParams({ f: fileName ?? '', w: 'small' });
  if (damageId) params.set('d', damageId);
  if (cache) params.set('oc', 'true');
  params.set('exp', String(token.exp));
  params.set('scope', token.scope);
  params.set('sig', token.sig);

  return `${token.baseUrl}?${params.toString()}`;
};

export const getThumbnailUrl = (fileName: string | undefined, damageId: string | undefined, cache: boolean = false): Promise<string> =>
  getValidToken().then((token) => buildThumbnailUrl(token, fileName, damageId, cache));
